import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const RESTORE_SUPPLY_REQUEST = 'RESTORE_SUPPLY_REQUEST';
export const RESTORE_SUPPLY_SUCCESS = 'RESTORE_SUPPLY_SUCCESS';
export const RESTORE_SUPPLY_ERROR = 'RESTORE_SUPPLY_ERROR';


export const restoreSupply = (id) => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: RESTORE_SUPPLY_REQUEST
            })
            axios({
                method: 'POST',
                url: `${SERVER_URL}v1/supply/${id}/restore`,
                headers: headers,
            }).then(function (response) {
                dispatch({
                    type: RESTORE_SUPPLY_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: RESTORE_SUPPLY_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}
